//export const server = "http://localhost:9009"
export const server = "https://api.casecount.lingosoft.co"
//export const server = "http://localhost:9099"
//export const server = "http://103.253.73.23:8009"
